module.exports = __webpack_public_path__ + "media/images/icons/chat-21ed1902285ab3fb6928fa6a7e4fe218.svg";